import { ReactNode } from 'react';
import { Trans } from '@lingui/react/macro';
import Typography from '@mui/material/Typography';

import {
  LOGIN_CUSTOMER_RELATION_OPTIONS,
  LoginCustomerRelationOption,
} from '@watershed/shared-universal/dashboardRoutes';

interface LoginMessagesProps {
  isTryingToAccessReport: boolean;
  isTryingToAccessCustomerHub: boolean;
  customerName?: string;
  watershedGeneric: string | null;
  customerRelation: LoginCustomerRelationOption | null;
}

function Message({ children }: { children: ReactNode }) {
  return (
    <Typography sx={{ mb: 3, textAlign: 'center' }}>{children}</Typography>
  );
}

export default function LoginMessages({
  isTryingToAccessReport,
  isTryingToAccessCustomerHub,
  customerName,
  watershedGeneric,
  customerRelation,
}: LoginMessagesProps) {
  const customerHub = isTryingToAccessCustomerHub && customerName;
  const isGenericCustomerHub = customerHub && watershedGeneric;
  const isCustomerHubNonGeneric = customerHub && !watershedGeneric;
  const isPortcoCustomerHub =
    customerHub &&
    customerRelation &&
    customerRelation === LOGIN_CUSTOMER_RELATION_OPTIONS.PORTCO;

  return (
    <>
      {isTryingToAccessReport && (
        <Message>
          <Trans>
            Author your annual ESG reports in Watershed and showcase your
            company's sustainability efforts and progress.
          </Trans>
        </Message>
      )}
      {isGenericCustomerHub && (
        <>
          <Message>
            <Trans>
              The Watershed Portal will allow you to estimate your carbon
              footprint and compare against your industry's average.
            </Trans>
          </Message>
          <Message>
            <Trans>
              To access the Watershed Portal, please enter your email address.
              Watershed will email you a link that you can use to securely sign
              in through your email account.
            </Trans>
          </Message>
        </>
      )}
      {isCustomerHubNonGeneric && (
        <>
          {isPortcoCustomerHub && (
            <Message>
              <Trans>
                <b>{customerName}</b> is working with their top portfolio
                companies to reduce the climate impact of their business.
              </Trans>
            </Message>
          )}
          <Message>
            <Trans>
              To access your Watershed dashboard and collaborate with{' '}
              {customerName}, please enter your email address. Watershed will
              send you a link that you can use to securely sign in through your
              email account.
            </Trans>
          </Message>
        </>
      )}
    </>
  );
}
